// "Volver a donde vine": UN contrato para todas las pantallas que se abren desde otra —
// ADR-2026-09-16-volver-a-donde-vine.
//
// Quien navega a un editor, un modo o una pantalla de acción pone en el `state` de la
// navegación `volverA: { path, state? }`; la pantalla destino, cuando el usuario quiere
// salir (Volver, Cancelar, la miga de la home, el back de mobile), va AHÍ y no a una ruta
// fija ni a la home. Nació porque desde el Agente se abren editores y modos que volvían
// a Creaciones o a la home: cada pantalla tenía su propio contrato de retorno
// (`volverAlVisor`, `returnPath`, `returnToResults`) o ninguno.
//
// Puro: se lee de `location.state`, que es `unknown` a todos los efectos.

export interface VolverA {
  path: string;
  state?: unknown;
}

export const CLAVE_VOLVER_A = 'volverA';

export function leerVolverA(state: unknown): VolverA | null {
  if (!state || typeof state !== 'object') return null;
  const v = (state as Record<string, unknown>)[CLAVE_VOLVER_A];
  if (!v || typeof v !== 'object') return null;
  const path = (v as { path?: unknown }).path;
  if (typeof path !== 'string' || !path.startsWith('/')) return null;
  return { path, state: (v as { state?: unknown }).state };
}

/** El `state` de una navegación con el `volverA` puesto (sin pisar el resto). */
export function conVolverA<T extends object>(state: T, volverA: VolverA): T & { volverA: VolverA } {
  return { ...state, [CLAVE_VOLVER_A]: volverA };
}
